import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MskKnowledgeAiHero from './components/MskKnowledgeAiHero';
import MskKnowledgeAiFeatures from './components/MskKnowledgeAiFeatures';
import MskKnowledgeAiUsage from './components/MskKnowledgeAiUsage';
import MskKnowledgeAiContact from './components/MskKnowledgeAiContact';

const MskKnowledgeAiPage = () => {
  usePageMeta({
    title: 'MSK AIアシスタント | 株式会社MSK',
    ogTitle: 'MSK AIアシスタント | 株式会社MSK',
    description:
      '社内マニュアル・仕様書・FAQを登録するだけで、AIが24時間365日自動回答するチャットボット「MSK AIアシスタント（Manual Support Knowledge）」の詳細ページです。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <MskKnowledgeAiHero />
        <MskKnowledgeAiFeatures />
        <MskKnowledgeAiUsage />
        <MskKnowledgeAiContact />
      </main>
      <Footer />
    </div>
  );
};

export default MskKnowledgeAiPage;
